import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Label, Col, Row} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import moment from "moment/moment";
import './AccreditationRequestDataModal.css';

class AccreditationRequestDataModal extends Component {
    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="accreditation-request-data-modal" isOpen={this.props.isOpen}
                   toggle={this.handleClose}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <Label>
                    <h5>{_.get(this.props.translation, 'accreditation_requests.accreditation_requests_details_label')}</h5>
                </Label>
                <h6>{_.get(this.props.translation, sharedLabelsPath.org_label)}</h6>
                {this.renderOrgData()}
                {this.renderAccreditationGroupData()}
                <h6>{_.get(this.props.translation, 'accreditation.accreditation_label')}</h6>
                {this.renderAccreditationOriginalTitle()}
                {this.renderAccreditationAdditionalTitles()}
                {this.renderAccreditationData()}
                <h6>{_.get(this.props.translation, 'accreditation_requests.vid_label')}</h6>
                {this.renderVIDData()}
                <div className="accreditation-request-data-buttons-container">
                    <Button className="olive-green-btn"
                            onClick={this.handleClose}>{_.get(this.props.translation, sharedLabelsPath.okey_button)}</Button>
                </div>
            </div>
        );
    }

    renderOrgData = () => {
        let paramsList = [
            {
                key: 'orgName',
                title: _.get(this.props.translation, "orgs.name_label"),
                value: this.props.data.orgName
            },
            {
                key: 'orgDomain',
                title: _.get(this.props.translation, sharedLabelsPath.domain_label),
                value: this.props.data.orgDomain
            }
        ];

        return [..._.map(paramsList, this.getDataRow)];
    };

    renderAccreditationGroupData = () => {
        if (!_.isNil(this.props.data.managingOrganizationId)) {
            return null;
        }
        let params = {
            key: 'accreditationGroupName',
            title: _.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_group_name_label'),
            value: this.props.data.accreditationGroupName
        };

        return [
            <h6>{_.get(this.props.translation, sharedLabelsPath.accreditation_group_label)}</h6>,
            this.getDataRow(params)
        ];
    };

    renderAccreditationOriginalTitle = () => {
        let paramsList = [
            {
                key: 'titleOrig',
                title: _.get(this.props.translation, 'accreditation.accreditation_title_orig_label'),
                value: this.props.data.titleOrig
            },
            {
                key: 'titleEn',
                title: _.get(this.props.translation, 'accreditation.accreditation_title_en_label'),
                value: this.props.data.titleEn
            }
        ];

        return [..._.map(paramsList, this.getDataRow)];
    };

    renderAccreditationAdditionalTitles = () => {
        if (_.keys(this.props.data.titlesAdditional).length === 0) {
            return null;
        }
        return (
            <Row className="modal-form-field-container">
                <Col sm={4}>
                    {_.get(this.props.translation, 'accreditation.additional_translations_label')}
                </Col>
                <Col>
                    {
                        _.chain(this.props.data.titlesAdditional)
                            .mapValues((title, key) => (
                                <Row key={key}>({_.get(this.props.translation, 'langs.' + key)}) {title}</Row>
                            ))
                            .values()
                            .value()
                    }
                </Col>
            </Row>
        )
    };

    renderAccreditationData = () => {
        let paramsList = [
            {
                key: 'level',
                title: _.get(this.props.translation, 'accreditation.level_label'),
                value: _.get(this.props.translation, 'levels.' + this.props.data.level)
            },
            {
                key: 'dateIssued',
                title: _.get(this.props.translation, 'accreditation.date_issued_label'),
                value: moment(this.props.data.dateIssued).format('LL')
            }
        ];

        return [..._.map(paramsList, this.getDataRow)];
    };

    renderVIDData = () => {
        let paramsList = [
            {
                key: 'firstName',
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                value: this.props.data.verifiedIdentity.firstName
            },
            {
                key: 'lastName',
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                value: this.props.data.verifiedIdentity.lastName
            },
            {
                key: 'nationalId',
                title: _.get(this.props.translation, sharedLabelsPath.national_id_label),
                value: this.props.data.verifiedIdentity.nationalId
            },
            {
                key: 'countryCode',
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                value: _.get(this.props.translation, 'countries.' + this.props.data.verifiedIdentity.countryCode)
            }
        ];

        return [..._.map(paramsList, this.getDataRow)];
    };

    getDataRow = (params) => {
        if (_.isNil(params.value)) {
            return null;
        }

        return (
            <Row className="modal-form-field-container" key={params.key}>
                <Col sm={4}>
                    {params.title}
                </Col>
                <Col>
                    {params.value}
                </Col>
            </Row>
        );
    };

    handleClose = () => {
        this.props.onClose();
    };
}

AccreditationRequestDataModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onClose: PropTypes.func
};

export default AccreditationRequestDataModal;



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/accreditationRequestDataModal/AccreditationRequestDataModal.js